/* eslint-disable react/no-unescaped-entities */
import React, { RefObject } from "react";
import Link from "next/link";
import { routes } from "@/utils/routes";
import dynamic from "next/dynamic";

const AgreementPartialLayout = dynamic(
  () => import("../generic/agreement-partial-layout"),
  { ssr: false }
);

const CreditCardConsentAgreementMain = () => {
  return (
    <AgreementPartialLayout
      title="Shipvista.com Credit Card Consent Agreement (the “Consent Agreement”)"
      subtitle="Last Updated: February 1st, 2022"
    >
      {({ handleRef }) => (
        <>
          <p style={{ fontWeight: 600 }}>
            Important: Please carefully read the following terms set out in this
            Consent Agreement. This Consent Agreement is between Shipvista.com
            ("Shipvista Corporation", "we" or "us") and you, the authorized
            individual or organization wanting to store payment credentials to
            be used to pay for Shipvista.com services (the "Cardholder" or
            "You") After reading this Consent Agreement, if you select the “I
            Agree” button below you agree to the following:
          </p>
          <ol>
            <li>
              <div>
                <h5
                  id="one"
                  ref={
                    handleRef("1. Consent to Stored Credentials", "one") as any
                  }
                >
                  Consent to Stored Credentials
                </h5>
                <p>
                  You hereby consent to Shipvista.com storing the credit card
                  information (each such credit card and accompanying
                  information being a “Stored Credential"). You acknowledge that
                  your Stored Credential(s) may contain personal information.
                  You acknowledge and agree that you are responsible for the
                  completeness and accuracy of the Stored Credential you store
                  in Shipvista.com’s Systems, whether you store directly
                  (customer profile) or provide to us to store indirectly (guest
                  check-out). To the fullest extent permissible by applicable
                  law, you acknowledge and agree that Shipvista.com will have no
                  liability associated with or arising from your failure to
                  maintain accurate information, including your failure to
                  receive important information and updates about or related to
                  this Consent Agreement. If Shipvista.com has reasonable
                  grounds to suspect that any information you provided to us is
                  untrue, inaccurate or incomplete, we may terminate or suspend
                  this Consent Agreement without notice or liability and/or
                  refuse to provide any Shipvista.com services to you. We
                  regularly review the security measures relating to our
                  storage; however, we cannot guarantee that information you
                  transmit or store via the Internet is entirely secure.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="two"
                  ref={handleRef("2. Use of Stored Credential", "two") as any}
                >
                  Use of Stored Credential
                </h5>
                <p>
                  You hereby consent that your Stored Credential may be used by
                  Shipvista.com as permitted in accordance with Shipvista.com’s
                  Privacy Statement available&nbsp;
                  {/* <a
                         href="https://shipvista.com/privacy-policy"
                         className="s3"
                         target="_blank"
                         rel="noreferrer"
                     >
                         HERE,
                     </a> */}
                  <Link
                    href={routes.privacyPolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    HERE
                  </Link>
                </p>
                <ol type="i">
                  <li>
                    to process payment for orders received and filled (subject
                    to verification);
                  </li>
                  <li>for pre-authorized credit card transactions; and</li>
                  <li>
                    to process any refunds as required. Stored Credential will
                    be stored in anonymized truncated form.
                  </li>
                </ol>
                <p>
                  Your Stored Credential will be linked to the online
                  Shipvista.com account you are logged into when you provide the
                  Stored Credential or, if you arrange for your credit card
                  information to be stored by calling Shipvista.com Customer
                  Service, your Stored Credential will be linked to the account
                  you identify to the Customer Service Representative. If there
                  are other users of the same Shipvista.com account (for
                  example, in the case of a business account with multiple users
                  having access or where a Mail Service Provider (MSP) has
                  access to the account), they will be able to view and use your
                  Stored Credential. In case of multiple users having access to
                  the same business account, they (other than an MSP) will be
                  able to view any history that we display of its use with that
                  account.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="three"
                  ref={handleRef("3. Modifications by you", "three") as any}
                >
                  Modifications by you
                </h5>
                <p>
                  You may make changes to your Stored Credential(s) through your
                  customer profile. Each time that you add or replace a credit
                  card, or a credit card detail, which form part of the Stored
                  Credentials, you must review and consent to the then current
                  version of this Consent Agreement in order to make such
                  change.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="four"
                  ref={
                    handleRef(
                      "4. Consent Duration, Withdraw and/or Termination",
                      "four"
                    ) as any
                  }
                >
                  Consent Duration, Withdraw and/or Termination
                </h5>
                <p>
                  This Consent Agreement shall remain in effect indefinitely or
                  until, i) you withdraw your consent including by removing your
                  Stored Credentials (effective upon your last order having been
                  invoiced and processed); or ii) a Stored Credential is no
                  longer effective (including but not limited to an expired or
                  declined credit card) as reasonably determined by us. You may
                  withdraw your consent provided hereunder or remove all Stored
                  Credential(s) through your account. For single use
                  transactions, the Stored Credential are automatically deleted
                  after the transaction is completed. The Stored Credential may
                  remain on internal information systems in a non-usable
                  tokenized form for a period of up to one year after your
                  consent has been withdrawn.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5 id="five" ref={handleRef("5. Amendments", "five") as any}>
                  Amendments
                </h5>
                <p>
                  Shipvista.com reserves the right, in its sole discretion, to
                  amend the terms of this Consent Agreement at any time. We will
                  notify you of any amendments made to this Consent Agreement by
                  posting a new version with notice that we deem to be
                  reasonable in the circumstances, including such notice on our
                  website at&nbsp;
                  <span
                    style={{
                      color: "#800080",
                      fontFamily: '"Times New Roman", serif',
                      fontStyle: "normal",
                      fontWeight: "normal",
                      textDecoration: "underline",
                      fontSize: "12pt",
                    }}
                  >
                    https://shipvista.com
                  </span>
                  . You hereby agree to each such amendment, unless you withdraw
                  your consent as per Section 4 above.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="six"
                  ref={handleRef("6. Charges, Fees and Taxes", "six") as any}
                >
                  Charges, Fees and Taxes
                </h5>
                <p>
                  The charges/fees composing a Payment Transaction will be
                  calculated in accordance with the rates applicable at the time
                  of tendering your order, and will include all applicable
                  taxes, charges and fuel and other surcharges as set out in our
                  Terms and Conditions of Service available&nbsp;
                  {/* <a
                         href="https://shipvista.com/terms-of-use"
                         className="s6"
                         target="_blank"
                         rel="noreferrer"
                     >
                         HERE
                     </a> */}
                  <Link
                    href={routes.terms}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    HERE
                  </Link>{" "}
                  as amended from time to time (the "Shipvista.com Service
                  Terms").You are also solely responsible for any interest,
                  fees, charges or expenses related to any payment or any
                  non-processed payment transaction for any reason other than
                  due to our error or omission, as determined in our sole
                  discretion.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5 id="seven" ref={handleRef("7. Disputes", "seven") as any}>
                  Disputes
                </h5>
                <p>
                  All disputes, including in relation to refunds or
                  cancellations concerning Shipvista.com services, shall be
                  governed by the terms and conditions applicable to the service
                  (which you will find{" "}
                  {/* <a
                         href="https://shipvista.com/terms-of-use"
                         className="s6"
                         target="_blank"
                         rel="noreferrer"
                     >
                         HERE
                     </a> */}
                  <Link
                    href={routes.terms}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    HERE
                  </Link>{" "}
                  or similar service agreement) in effect between us and you at
                  the time of tendering the shipments in question.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="eight"
                  ref={handleRef("8. Limitation of Liability", "eight") as any}
                >
                  Limitation of Liability
                </h5>
                <p>
                  YOU UNDERSTAND AND AGREE THAT IN NO EVENT WILL SHIPVISTA.COM,
                  ITS AFFILIATE OR SUBSIDIARIES, AND EACH OF THEIR RESPECTIVE
                  EMPLOYEES, OFFICERS, DIRECTORS AND REPRESENTATIVES (EACH A "
                  PARTY", TOGETHER, THE "SHIPVISTA.COM PARTIES"), BE RESPONSIBLE
                  OR LIABLE TO YOU OR ANY THIRD PARTY, AS RELATED TO THIS
                  CONSENT AGREEMENT, A STORED CREDENTIAL OR A PAYMENT
                  TRANSACTION, FOR ANY DIRECT, INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, COMPENSATORY, SPECIAL, PUNITIVE OR EXEMPLARY
                  DAMAGES OR LOSSES OF ANY KIND, INCLUDING BUT NOT LIMITED TO
                  DAMAGES FOR LOSS OF PROFITS OR EARNINGS, LOSS OF ANTICIPATED
                  PROFITS OR EARNINGS, GOODWILL, USE, DATA OR OTHER INTANGIBLE
                  LOSSES WHICH MAY BE INCURRED, REGARDLESS OF THE TYPE OF CLAIM
                  OR CAUSE OF ACTION, WHETHER SUCH CLAIM OR CAUSE SOUNDS IN
                  CONTRACT, TORT, NEGLIGENCE OR OTHERWISE, OR COULD HAVE
                  REASONABLY BEEN FORESEEN BY YOU OR ANY THIRD PARTY. NO
                  SHIPVISTA.COM’s PARTY WILL BE LIABLE TO YOU OR A THIRD PARTY
                  FOR ANY FAILURE TO PERFORM ANY OBLIGATIONS SET OUT HEREIN,
                  WHETHER DIRECTLY OR INDIRECTLY, DUE TO THE FAILURE OF ANY
                  EQUIPMENT, TRANSMISSION OR TECHNICAL PROBLEMS, LABOUR
                  DISPUTES, WAR, NATURAL DISASTER, ACT OF TERRORISM, EXPLOSION,
                  ACT OF GOD OR ANY OTHER EVENT BEYOND OUR REASONABLE CONTROL.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="nine"
                  ref={handleRef("9. Indemnification", "nine") as any}
                >
                  Indemnification
                </h5>
                <p>
                  To the fullest extent permitted by applicable law, you agree
                  to indemnify, defend and hold harmless each Shipvista.com
                  Party from any loss, claim, liability, damages, demand, costs,
                  charges and fines in connection with, arising out of or due to
                  your breach of this Consent Agreement.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="ten"
                  ref={handleRef("10. Eligibility and Conduct", "ten") as any}
                >
                  Eligibility and Conduct
                </h5>
                <p>You represent and warrant that you:</p>
                <ul>
                  <li>
                    are the age of majority in accordance with the laws of your
                    province/territory of residence;
                  </li>
                  <li>
                    are the individual duly authorized on behalf of yourself or
                    your organization to store any payment credential as a
                    Stored Credential hereunder;
                  </li>
                  <li>shall not breach the terms of this Consent Agreement;</li>
                  <li>
                    shall only use the customer profile or guest check-out
                    feature, and provide the payment information, as permitted
                    by law;
                  </li>
                  <li>
                    shall not consent to this Consent Agreement in order to
                    conduct any fraudulent, unlawful or abusive acts;
                  </li>
                  <li>
                    shall not disrupt or interfere with the security operation
                    of, or otherwise abuse the functionality of storing
                    information on the Shipvista.com Systems;
                  </li>
                  <li>
                    shall not attempt to obtain unauthorized access in relation
                    to other Shipvista.com Systems;
                  </li>
                  <li>
                    shall comply with any other requirements, restrictions or
                    limitations imposed by Shipvista.com from time to time; and
                  </li>
                  <li>
                    That you understand and agree to be bound by all the terms
                    and conditions as set out herein.
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div>
                <h5
                  id="eleven"
                  ref={handleRef("11. General Terms", "eleven") as any}
                >
                  General Terms
                </h5>
                <p>
                  This Consent Agreement shall be construed in accordance with
                  and shall be governed by the laws of the Province of Ontario
                  or the province or Territory where the cardholder resides and
                  the laws of Canada applicable therein.
                </p>

                <p>
                  Our failure or delay to exercise or enforce any provision or
                  right contained herein shall not be deemed a waiver or such
                  provision or right; any waiver of any provision or right shall
                  be expressly set out in writing to be effective.
                </p>

                <p>
                  Any provision of this Consent Agreement that is prohibited or
                  unenforceable in any jurisdiction shall, as to such
                  jurisdiction, be ineffective to the extent of such prohibition
                  or unenforceability without invalidating the remaining
                  provisions hereof or affecting the validity or enforceability
                  of such provision in any other jurisdiction.
                </p>

                <p>
                  Headings are for convenience only and not included for
                  purposes of interpretation.
                </p>

                <p>
                  You may not assign this Consent Agreement, in whole or in
                  part, at any time.
                </p>

                <p>
                  This Consent Agreement constitutes the entire agreement
                  between you and us relating to the matters herein raised.
                </p>

                <p>
                  The terms of this Consent Agreement that by their nature are
                  intended to survive the termination or expiration of this
                  Consent Agreement (including liability, indemnification and
                  privacy obligations) shall survive.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h5 id="twelve" ref={handleRef("12. Contact", "twelve") as any}>
                  Contact
                </h5>
                <p>
                  You may contact Shipvista.com through appropriate telephone
                  numbers on Shipvista.com website (
                  <span style={{ color: "#0467C5" }}>HERE</span>)
                </p>
              </div>
            </li>
          </ol>
        </>
      )}
    </AgreementPartialLayout>
  );
};

export default CreditCardConsentAgreementMain;
